// extracted by mini-css-extract-plugin
export default {"container":"AnimatedSwitcher-module_container_cXn1eL","page":"AnimatedSwitcher-module_page_W_yGdj"};